<template>
  <v-chip
    x-small
    class="field-tag-chip mr-1 mb-1"
    :close="closable"
    @click:close="handleClose"
  >
    <span class="field-tag-chip__label">{{ label }}</span>
    <FieldTagChainDialog
      v-if="showChain"
      v-model="chainOpen"
      :field-tag="tag"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          x-small
          color="primary"
          class="field-tag-chip__chain"
          type="button"
          v-bind="attrs"
          v-on="on"
          @click.stop
          @mousedown.stop
        >
          <v-icon size="12">kt-menu__link-icon flaticon-map</v-icon>
        </v-btn>
      </template>
    </FieldTagChainDialog>
  </v-chip>
</template>

<script>
import FieldTagChainDialog from "@/views/pages/fieldTags/partials/FieldTagChainDialog.vue";

export default {
  name: "FieldTagChip",
  components: {
    FieldTagChainDialog,
  },
  props: {
    tag: {
      type: Object,
      required: true,
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chainOpen: false,
    };
  },
  computed: {
    label() {
      return this.tag?.value || "";
    },
    showChain() {
      return !!this.tag?.id && this.hasPermissions("field-tags-view-all");
    },
  },
  methods: {
    handleClose(event) {
      if (event) {
        event.stopPropagation();
      }

      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.field-tag-chip.v-chip {
  height: auto;
  min-height: 20px;
  padding-right: 2px;
}

.field-tag-chip__label {
  line-height: 1.2;
}

.field-tag-chip__chain.v-btn {
  height: 16px;
  margin: 0 0 0 2px;
  width: 16px;
}

.field-tag-chip__chain.v-btn ::v-deep .v-icon {
  font-size: 12px;
  height: 12px;
  width: 12px;
}
</style>
